export default __webpack_public_path__ + "static/media/VIERNES.832c7063.jpeg";